import AbstractResource from '@/zenky/resources/AbstractResource';
import ResourceNotifications from '@/zenky/resources/ResourceNotifications';

export default class ResourceProxy {
  private notifications!: ResourceNotifications;
  protected resource: AbstractResource<any>

  constructor(resource: AbstractResource<any>) {
    this.resource = resource;
  }

  protected getNotifications(): ResourceNotifications {
    if (!this.notifications) {
      this.notifications = this.createNotifications();
    }

    return this.notifications;
  }

  protected createNotifications(): ResourceNotifications {
    return this.resource.notifications();
  }

  getShowApiUrl(itemId: string) {
    return this.resource.showApiUrl(itemId);
  }

  getDestroyApiUrl(itemId: string) {
    return this.resource.destroyApiUrl(itemId);
  }

  getConfirmMessage(item: any): string {
    return this.resource.messages().confirm(item);
  }

  getIndexRoute() {
    return this.resource.indexRoute();
  }

  getDestroyRoute(item: any) {
    return this.resource.destroyRoute(item);
  }

  getUpdatedNotification(item: any) {
    return this.getNotifications().updated(item);
  }

  getUpdateFailedNotification(item: any, err: any) {
    return this.getNotifications().updateFailed(item, err);
  }

  getDeletedNotification(item: any) {
    return this.getNotifications().deleted(item);
  }

  getDeleteFailedNotification(item: any, err: any) {
    return this.getNotifications().deleteFailed(item, err);
  }

  getEditForm(item: any) {
    return this.resource.editForm(item);
  }

  getEditFormSubmitter(item: any) {
    return this.resource.editFormSubmitter(item);
  }

  getSidebar(item: any) {
    return this.resource.sidebar(item);
  }
};
